import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signOut } from '../../redux/action/Auth';

const DEFAULT_TIMEOUT_S = 900;

const AppLogout = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let timer;
  const events = [
    'load',
    'mousemove',
    'mousedown',
    'click',
    'scroll',
    'keypress',
  ];
  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };

  const getTimeoutMs = () => {
    const TimeOut = localStorage.getItem('logOutTime');
    if (TimeOut) return parseInt(TimeOut, 10) * 1000;
    return DEFAULT_TIMEOUT_S * 1000;
  };

  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      resetTimer();
      Object.values(events).forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });

      logoutAction();
    }, getTimeoutMs());
  };
  useEffect(() => {
    Object.values(events).forEach((item) => {
      window.addEventListener(item, () => {
        resetTimer();
        handleLogoutTimer();
      });
    });
  }, []);
  const logoutAction = () => {
    dispatch(signOut());
    navigate('/auth/login');
  };

  return children;
};
export default AppLogout;
